import React, { useState } from "react";

export default function GoogleAuthSetup() {
  const [idSunfish, setIdSunfish] = useState("");
  const [qrUrl, setQrUrl] = useState("");
  const [secret, setSecret] = useState("");
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState(1);
  const [error, setError] = useState("");

  /**
   * MASK ID
   */
  const maskId = (id) => {
    if (!id) return "";
    const str = String(id);
    return str.slice(0, 2) + "*".repeat(str.length - 4) + str.slice(-2);
  };

  /**
   * =========================
   * SETUP QR
   * =========================
   */
  const handleSetup = async () => {
    if (!idSunfish) {
      return setError("ID Sunfish wajib diisi");
    }

    setLoading(true);
    setError("");

    try {
      const res = await fetch("/api/2fa/setup", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id_sunfish: idSunfish }),
      });

      const data = await res.json();

      if (data.success) {
        setQrUrl(data.qr);
        setSecret(data.secret);
        setStep(2);
      } else {
        setError(data.message);
      }
    } catch (err) {
      setError("Server error");
    } finally {
      setLoading(false);
    }
  };

  /**
   * =========================
   * VERIFY OTP
   * =========================
   */
  const handleVerify = async () => {
    if (!otp) return alert("Masukkan OTP");

    try {
      const res = await fetch("/api/2fa/verify", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id_sunfish: idSunfish,
          token: otp,
        }),
      });

      const data = await res.json();

      if (data.success) {
        setStep(3);
      } else {
        alert(data.message);
      }
    } catch (err) {
      alert("Server error");
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        Loading...
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 p-6">

      <div className="w-full max-w-2xl bg-white rounded-xl shadow p-6">

        <h1 className="text-xl font-bold text-center mb-6">
          Google Authenticator Setup
        </h1>

        {/* STEP 1 */}
        {step === 1 && (
          <div className="space-y-4">
            <input
              value={idSunfish}
              onChange={(e) => setIdSunfish(e.target.value)}
              placeholder="Masukkan ID Sunfish"
              className="w-full border p-3 rounded text-center"
            />

            <button
              onClick={handleSetup}
              className="w-full bg-black text-white p-3 rounded"
            >
              Generate QR
            </button>
          </div>
        )}

        {/* STEP 2 */}
        {step === 2 && (
          <div className="space-y-4 text-center">

            <h2 className="font-bold">
              {maskId(idSunfish)}
            </h2>

            <img src={qrUrl} className="mx-auto w-48 h-48" />

            <p className="text-xs break-all">{secret}</p>

            <input
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              placeholder="6 digit OTP"
              className="border p-3 w-full text-center tracking-[0.5em]"
            />

            <button
              onClick={handleVerify}
              className="w-full bg-black text-white p-3 rounded"
            >
              Verify OTP
            </button>
          </div>
        )}

        {/* STEP 3 */}
        {step === 3 && (
          <div className="text-center text-green-600 font-bold">
            2FA Berhasil Diaktifkan ✔
          </div>
        )}

        {error && (
          <p className="text-red-500 text-center mt-3">{error}</p>
        )}
      </div>
    </div>
  );
}